
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subprocessors",
      function () {
        return require("private-next-pages/subprocessors.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subprocessors"])
      });
    }
  